import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import {
  JourneyPosition,
  reservationService,
  useYardSetupMessageHandler,
  YardPositionSelector,
} from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { ContainerTurnoverListViewStore } from '../../stores/container-turnover-list.view-store'

interface Props {
  listStore: ContainerTurnoverListViewStore
}
export const ContainerTurnoversReservationDialog = observer(({ listStore }: Props) => {
  const { t } = useTranslate()
  const [journeyPosition, setJourneyPosition] = useState<JourneyPosition | undefined>(undefined)
  const [triedToSubmit, setTriedToSubmit] = useState(false)
  const { getExceptionMessage, getReservationSuccessMessage } = useYardSetupMessageHandler()

  const handleSubmit = async () => {
    try {
      setTriedToSubmit(true)

      if (!journeyPosition) return
      await reservationService.create({
        journeyId: listStore.selectedJourneyId!,
        blockId: journeyPosition.blockId,
        position:
          journeyPosition.bay && journeyPosition.row && journeyPosition.tier
            ? {
                bay: journeyPosition.bay,
                row: journeyPosition.row,
                tier: journeyPosition.tier,
              }
            : undefined,
      })

      listStore.toggleReservationDialog()
      setJourneyPosition(undefined)
      setTriedToSubmit(false)
      appStore.setShowAlert('success', getReservationSuccessMessage())
    } catch (error) {
      appStore.setShowAlert('error', getExceptionMessage(error))
    }
  }

  return (
    <ConfirmationDialog
      open={listStore.isReservationDialogOpen}
      title={t('createReservationFor', 'Create reservation for {containerNumber}', {
        containerNumber: listStore.selectedContainerNumber,
      })}
      primaryActionText={t('yesCreate', 'Yes, create')}
      closeLabel={t('noCancel', 'No, cancel')}
      maxWidth='md'
      onClose={() => listStore.toggleReservationDialog()}
      onConfirm={handleSubmit}
    >
      <YardPositionSelector
        journeyId={listStore.selectedJourneyId!}
        hasError={triedToSubmit && !journeyPosition}
        onChange={position => setJourneyPosition(position)}
      />
    </ConfirmationDialog>
  )
})
